var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropdownCollapse = function SvgDropdownCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.372 11.87a.433.433 0 0 1-.619 0L10 9.073 7.247 11.87a.433.433 0 0 1-.619 0 .45.45 0 0 1 0-.629l3.063-3.11a.433.433 0 0 1 .618 0l3.063 3.11a.45.45 0 0 1 0 .629Z",
    fill: "#666"
  })));
};
export default SvgDropdownCollapse;